/**
 * Set of connector `source` identifiers that represent Atlassian first-party
 * apps. The discover apps tab in the Rovo settings modal is meant to surface
 * only third-party connectors for now, so anything in this list should be
 * filtered out before rendering.
 *
 * Most values below mirror the entries in the assistance-service
 * `KnowledgeSourceType` enum that do NOT carry a `thirdPartyConnectorKey`:
 * https://bitbucket.org/atlassian/conversational-ai-platform/src/main/modules/platform/base/base-api/src/main/kotlin/io/atlassian/micros/convoai/platform/base/knowledge/KnowledgeSourceType.kt
 *
 * Note: `loom` is included here even though it is classified as 3p in
 * assistance-service/search, because product-side it is treated as a
 * first-party Atlassian app and should not appear in the discovery tab.
 */
export const FIRST_PARTY_SOURCES: ReadonlySet<string> = new Set([
	'confluence',
	'compass',
	'csm',
	'jira',
	'jsm',
	'atlas',
	'atlas_project',
	'atlas_goal',
	'help_aggregator',
	'web_search',
	'trello',
	'forge',
	'bitbucket',
	'loom',
]);

/**
 * Returns true when the given connector source is a known Atlassian first-party
 * app.
 */
export const isFirstPartySource = (source: string): boolean => FIRST_PARTY_SOURCES.has(source);
